<template>
  <div class="icon-box player-icon-buttons">
    <ul>
      <!--      관심 버튼 -->
      <li class="icon-item">
        <BtnZzimWithApi
          :key="contentId"
          :is-on="isLikeOn"
          :block-zzim="contentId === ''"
          :contents-type="contentsType"
          :contents-id="contentId"
        />
      </li>

      <!--      공유 버튼-->
      <li class="icon-item">
        <button type="button" @click.prevent="$emit('on-click-share')">
          <img :src="shareImage" width="30" height="30" alt="공유" />
          <span class="icon-txt">공유</span>
        </button>
      </li>
    </ul>
  </div>
</template>
<script setup>
  import { computed, defineProps, defineEmits } from 'vue'
  import BtnZzimWithApi from '@/components/button/BtnZzimWithApi.vue'
  import shareImage from '@/assets/images/common/element-icons-30-x-30-ic-detail-share.svg'

  const props = defineProps({
    contentInfo: {
      type: Object,
      default: () => {},
    },
    contentType: {
      type: String,
      default: '',
    },
  })

  defineEmits(['on-click-share'])

  const isMovie = computed(() => props.contentType === 'movie')
  const contentsType = computed(() => {
    return props.contentType === 'vod' ? 'program' : props.contentType
  })
  const movieId = computed(() => props.contentInfo?.movieid ?? '')
  const programId = computed(() => props.contentInfo?.programid ?? '')
  const contentId = computed(
    () => (isMovie.value ? movieId.value : programId.value) ?? '',
  )
  const isLikeOn = computed(() => props.contentInfo?.zzim ?? 'n')
</script>
